module.exports = __webpack_public_path__ + "static/media/tavernello-logo.800538f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tavernello-logo.png
// module id = 746
// module chunks = 0